import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i3 from 'base-support-letter-library';
import { BaseSupportLetterLibraryService } from 'base-support-letter-library';
import * as i8 from 'place-holder-library';
import { PlaceHolderDirective, PlaceHolderLibraryModule } from 'place-holder-library';
import { TaskStep } from 'app-models';
import * as i1 from '@ngrx/store';
import * as i2 from 'ngx-toastr';
import * as i4 from 'app-services-library';
import * as i5 from 'primeng/radiobutton';
import * as i6 from '@angular/forms';
import * as i7 from '@angular/common';
import * as i9 from '@angular/material/icon';
import * as i10 from 'primeng/tooltip';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PdfViewLibraryModule } from 'pdf-view-library';
import { LetterPreviewLibraryModule } from 'letter-preview-library';
import { LetterTemplateLibraryModule } from 'letter-template-library';
import { DigitalSignatureLibraryModule } from 'digital-signature-library';

class SupportLetterLibraryService {
    constructor() { }
}
SupportLetterLibraryService.ɵfac = function SupportLetterLibraryService_Factory(t) { return new (t || SupportLetterLibraryService)(); };
SupportLetterLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: SupportLetterLibraryService, factory: SupportLetterLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SupportLetterLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function SupportLetterLibraryComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "div", 11);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵelementStart(4, "button", 13);
    i0.ɵɵtext(5, "Upload a file");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "input", 14, 15);
    i0.ɵɵlistener("change", function SupportLetterLibraryComponent_div_11_Template_input_change_6_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.uploadForm($event.target.files); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 16);
    i0.ɵɵtext(9, "(Supported file type: .pdf)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r0.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.disabledControls);
} }
const _c0 = function (a0) { return { "disabled": a0 }; };
function SupportLetterLibraryComponent_table_13_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table", 17);
    i0.ɵɵelementStart(1, "thead", 18);
    i0.ɵɵelementStart(2, "tr");
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Uploaded On");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 19);
    i0.ɵɵtext(10, " Actions ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "tbody");
    i0.ɵɵelementStart(12, "tr");
    i0.ɵɵelementStart(13, "td");
    i0.ɵɵelementStart(14, "strong");
    i0.ɵɵtext(15, "Support Letter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td", 20);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td", 20);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td", 20);
    i0.ɵɵelementStart(21, "div", 21);
    i0.ɵɵelementStart(22, "div", 22);
    i0.ɵɵelementStart(23, "mat-icon", 23);
    i0.ɵɵlistener("click", function SupportLetterLibraryComponent_table_13_Template_mat_icon_click_23_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.viewDocument(ctx_r6.fileSrc); });
    i0.ɵɵtext(24, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 22);
    i0.ɵɵelementStart(26, "span");
    i0.ɵɵelementStart(27, "mat-icon", 24);
    i0.ɵɵlistener("click", function SupportLetterLibraryComponent_table_13_Template_mat_icon_click_27_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.deleteUploadedDocument(ctx_r8.documentId); });
    i0.ɵɵtext(28, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(17);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.uploadedFileName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.generatedOn, " ");
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx_r1.disabledControls));
} }
function SupportLetterLibraryComponent_ng_template_16_Template(rf, ctx) { }
const _c1 = function (a0, a1) { return { "visible": a0, "invisible": a1 }; };
class SupportLetterLibraryComponent extends BaseSupportLetterLibraryService {
    constructor(store, toastr, componentFactoryResolver, apiService, appServicesLibraryService) {
        super(store, toastr, componentFactoryResolver, apiService, appServicesLibraryService);
        this.store = store;
        this.toastr = toastr;
        this.componentFactoryResolver = componentFactoryResolver;
        this.apiService = apiService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.stepDetails = TaskStep;
        this.disabledControls = false;
        this.onDialogClose = new EventEmitter();
    }
    ngOnInit() {
        this.supportLetterPlaceHolder = this.supportLetterPlaceHolder;
        this.inputData = this.primaryData;
        super.loadInit();
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnChanges() {
        if (sessionStorage.getItem('wizardTID') == null) {
            this.toggleControlsStatus();
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    toggleControlsStatus() {
        this.disabledControls =
            this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT";
    }
}
SupportLetterLibraryComponent.ɵfac = function SupportLetterLibraryComponent_Factory(t) { return new (t || SupportLetterLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i3.APISupportLetter), i0.ɵɵdirectiveInject(i4.AppServicesLibraryService)); };
SupportLetterLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SupportLetterLibraryComponent, selectors: [["support-letter-library"]], viewQuery: function SupportLetterLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PlaceHolderDirective, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.supportLetterPlaceHolder = _t.first);
    } }, inputs: { primaryData: "primaryData" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 17, vars: 10, consts: [[1, "col-md-12", "pr-0"], [1, "col-6", "float-left"], [1, "row"], ["name", "generateForm", "label", "Generate Letter", 1, "letter-radio", 3, "ngModel", "value", "onClick", "ngModelChange"], ["name", "generateForm", "label", "Upload Letter", 1, "letter-radio", 3, "ngModel", "value", "onClick", "ngModelChange"], [1, "clearfix"], ["class", "row", 4, "ngIf"], [1, "col-12"], ["class", "im-card-no-border-table file-upload-list table-striped-simple", "style", "margin-top: 20px; width: 100%;", 4, "ngIf"], [1, "col-md-12", "pr-0", 2, "margin-top", "25px", 3, "ngClass"], ["dynamicComponentPlaceHolder", ""], [1, "col-6"], [1, "upload-btn-wrapper"], [1, "btn-success", "btn", 3, "disabled"], ["type", "file", "name", "myfile", 3, "disabled", "change"], ["myfile", ""], [1, "supportFileText"], [1, "im-card-no-border-table", "file-upload-list", "table-striped-simple", 2, "margin-top", "20px", "width", "100%"], [2, "height", "30px"], [1, "text-center"], ["nowrap", ""], [1, "d-flex", "flex-row", "align-items-center", "justify-content-center"], [1, "mr-2", "padding0"], ["pTooltip", "View", 1, "material-icons", 3, "click"], ["pTooltip", "Delete", 1, "material-icons", 3, "ngClass", "click"]], template: function SupportLetterLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "p");
        i0.ɵɵtext(2, "Would you like to use system generated letter or upload your own letter?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelementStart(5, "p-radioButton", 3);
        i0.ɵɵlistener("onClick", function SupportLetterLibraryComponent_Template_p_radioButton_onClick_5_listener() { return ctx.handleGenerateForm(true); })("ngModelChange", function SupportLetterLibraryComponent_Template_p_radioButton_ngModelChange_5_listener($event) { return ctx.isGenerated = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 1);
        i0.ɵɵelementStart(7, "div", 2);
        i0.ɵɵelementStart(8, "p-radioButton", 4);
        i0.ɵɵlistener("onClick", function SupportLetterLibraryComponent_Template_p_radioButton_onClick_8_listener() { return ctx.handleGenerateForm(false); })("ngModelChange", function SupportLetterLibraryComponent_Template_p_radioButton_ngModelChange_8_listener($event) { return ctx.isGenerated = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(10, "div", 5);
        i0.ɵɵtemplate(11, SupportLetterLibraryComponent_div_11_Template, 10, 2, "div", 6);
        i0.ɵɵelementStart(12, "div", 7);
        i0.ɵɵtemplate(13, SupportLetterLibraryComponent_table_13_Template, 29, 5, "table", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 5);
        i0.ɵɵelementStart(15, "div", 9);
        i0.ɵɵtemplate(16, SupportLetterLibraryComponent_ng_template_16_Template, 0, 0, "ng-template", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngModel", ctx.isGenerated)("value", true);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.isGenerated)("value", false);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isGenerated);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isGenerated && ctx.isUploaded);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c1, ctx.isGenerated, !ctx.isGenerated));
    } }, directives: [i5.RadioButton, i6.NgControlStatus, i6.NgModel, i7.NgIf, i7.NgClass, i8.PlaceHolderDirective, i9.MatIcon, i10.Tooltip], styles: [".upload-btn-wrapper[_ngcontent-%COMP%]{position:relative;overflow:hidden;display:inline-block;margin-top:20px}.btn[_ngcontent-%COMP%]{border:0;color:#fff;padding:8px 20px;border-radius:8px;font-size:20px;font-weight:700}.upload-btn-wrapper[_ngcontent-%COMP%]   input[type=file][_ngcontent-%COMP%]{font-size:100px;position:absolute;left:0;top:0;opacity:0}.supportFileText[_ngcontent-%COMP%]{font-size:11px;font-style:italic;color:#d3d3d3}.disabled[_ngcontent-%COMP%]{pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SupportLetterLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'support-letter-library',
                templateUrl: 'support-letter-library.component.html',
                styleUrls: ['support-letter-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.ToastrService }, { type: i0.ComponentFactoryResolver }, { type: i3.APISupportLetter }, { type: i4.AppServicesLibraryService }]; }, { primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], supportLetterPlaceHolder: [{
            type: ViewChild,
            args: [PlaceHolderDirective, { static: true }]
        }] }); })();

class SupportLetterLibraryModule {
}
SupportLetterLibraryModule.ɵfac = function SupportLetterLibraryModule_Factory(t) { return new (t || SupportLetterLibraryModule)(); };
SupportLetterLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupportLetterLibraryModule });
SupportLetterLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseSupportLetterLibraryService], imports: [[
            PlaceHolderLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            PrimengLibraryModule,
            PdfViewLibraryModule,
            LetterPreviewLibraryModule,
            LetterTemplateLibraryModule,
            DigitalSignatureLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SupportLetterLibraryModule, { declarations: [SupportLetterLibraryComponent], imports: [PlaceHolderLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        PrimengLibraryModule,
        PdfViewLibraryModule,
        LetterPreviewLibraryModule,
        LetterTemplateLibraryModule,
        DigitalSignatureLibraryModule], exports: [SupportLetterLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SupportLetterLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [SupportLetterLibraryComponent],
                imports: [
                    PlaceHolderLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    PrimengLibraryModule,
                    PdfViewLibraryModule,
                    LetterPreviewLibraryModule,
                    LetterTemplateLibraryModule,
                    DigitalSignatureLibraryModule
                ],
                providers: [BaseSupportLetterLibraryService],
                exports: [SupportLetterLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of support-letter-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SupportLetterLibraryComponent, SupportLetterLibraryModule, SupportLetterLibraryService };
//# sourceMappingURL=support-letter-library.js.map
